import apiClient from './apiClient';

// F103 interface matching backend model
export interface F103 {
  f103_01: string;   // 姓名 (PK)
  f103_11: string;   // 姓名(Page1)
  f103_12: string;   // 英文姓名
  f103_13: string | null;  // 生日
  f103_14: string;   // 性別
  f103_15: string;   // 血型
  f103_16: string;   // 國別
  f103_17: string;   // 區域(州.省.市)
  f103_18: string;   // 戶籍住址
  f103_19: string;   // 通訊地址
  f103_20: string;   // 郵遞區號
  f103_21: string;   // 聯絡電話
  f103_22: string;   // 行動電話1
  f103_221: string;  // 行動電話2
  f103_23: string;   // 呼叫器
  f103_24: string;   // 傳真
  f103_25: string;   // 電子郵件
  f103_26: string;   // 網址
  f103_27: string;   // 專線電話
  f103_28: string;   // 呼叫器(舊)
  f103_29: string;   // 來源
  f103_30: number;   // 親友計數
  f103_31: string;   // 關係
  f103_32: string;   // 婚姻
  f103_33: string;   // 英文地址
  f103_34: string;   // 嗜好
  f103_35: string;   // 宗教信仰
  f103_36: string;   // 備註
  f103_37: string;   // 提供人
  f103_91: string;   // 建立人員代號
  f103_92: string | null;  // 建立日期
  f103_93: string;   // 最後異動人員代號
  details_1031?: F1031[];
  details_1032?: F1032[];
  details_1033?: F1033[];
}

export interface F1031 {
  f1031_01: string;  // 姓名FK
  f1031_02: number;  // 序號
  f1031_11: string;  // 關係
  f1031_12: string;  // 姓名
  f1031_13: string | null;  // 生日
  f1031_14: string;  // 年齡
  f1031_21: string;  // 備註
  f1031_51: string;  // 其他
}

export interface F1032 {
  f1032_01: string;   // 姓名FK
  f1032_02: string;   // 序號(公司代號)
  f1032_021: string;  // 英文公司名稱
  f1032_11: string;   // 關係
  f1032_12: string;   // 姓名
  f1032_13: string;   // 生日
  f1032_14: string;   // 年齡
  f1032_15: string;   // 備註
  f1032_16: string;   // 公司郵件
}

export interface F1033 {
  f1033_01: string;  // 姓名FK
  f1033_02: string;  // 公司代號FK
  f1033_11: string;  // 類別
  f1033_12: string;  // 地址
  f1033_13: string;  // 英文地址(類別)
  f1033_14: string;  // 地址
}

export interface ListResponse {
  data: F103[];
  total: number;
  page: number;
  size: number;
}

export interface ValidationError {
  field: string;
  code: string;
  message: string;
}

const BASE = '/api/business-card';

const businessCardApi = {
  list: async (page = 1, size = 100, keyword?: string): Promise<ListResponse> => {
    if (keyword) {
      const res = await apiClient.get(`${BASE}/search`, { params: { keyword, page, size } });
      return res.data;
    }
    const res = await apiClient.get(BASE, { params: { page, size } });
    return res.data;
  },

  search: async (keyword: string, page = 1, size = 20): Promise<ListResponse> => {
    const res = await apiClient.get(`${BASE}/search`, { params: { keyword, page, size } });
    return res.data;
  },

  get: async (name: string): Promise<F103> => {
    const res = await apiClient.get(`${BASE}/${encodeURIComponent(name)}`);
    return res.data;
  },

  create: async (data: Partial<F103>): Promise<F103> => {
    const res = await apiClient.post(BASE, data);
    return res.data;
  },

  update: async (name: string, data: Partial<F103>): Promise<F103> => {
    const res = await apiClient.put(`${BASE}/${encodeURIComponent(name)}`, data);
    return res.data;
  },

  delete: async (name: string): Promise<void> => {
    await apiClient.delete(`${BASE}/${encodeURIComponent(name)}`);
  },
};

export default businessCardApi;
